import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { ServiceViewModel } from '../../business-entities/service-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { SettingService } from '../../business-services/setting.service';
import { CultureLocaleService } from '../../services/culture-locale.service';
import { SecureStorage } from './../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdSortableHeader, SortEvent } from './../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from './../../../../../Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from './../../../../../Autofacets-Core/src/app/utils/constant';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { ServicesService } from './../../business-services/services.service';
import { AddServiceComponent } from './add-service/add-service.component';
import { EditServiceComponent } from './edit-service/edit-service.component';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { DashboardService } from '../../business-services/dashboard.service';
import { LaborService } from '../../business-services/labor.service';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { DMSSyncFailedLogRequestModel } from '../../business-entities/dmssyncfailedlog-request-model';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { ApplicationSourceService } from '../../business-services/application-source.service';
@Component({
  selector: 'app-services',
  templateUrl: './services.component.html'
})


export class ServicesComponent implements OnInit, OnDestroy {
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  isAdvanceSearch: any;
  servicesList: any = [];
  paginationSub: Subscription;
  currentlagSub: Subscription;
  subscription : Subscription;
  userRoleRightsDetails: UserRoleMenu;
  popupCloseResult = false;
  StatusList: StatusViewModel[] = [];
  SyncList: StatusViewModel[] = [];
  applicationSourceList: any[] = [];
  SourceId:number;
  selectedStatus: number;
  sourceName:string;
  totalCount: number = 0;
  integrationWithDMS: boolean = false;
  needAttention: boolean = false;
  displayPriceInWidget : boolean = false;
  isFixed:boolean = false;
  checkListSelected:boolean = false;
  isCustomerComment : boolean =false;
  throttle = 100;
  scrollDistance = 1;
  searchTerm: string;
  selectedSync: number;
  dmsLogRequestModel: DMSSyncFailedLogRequestModel =
  {
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    moduleId: Enums.ModuleNames.Service,
    logDate: '',
    referenceId: 0
  };
  isDmsSyncService: boolean = false;


  constructor(
    { nativeElement }: ElementRef<HTMLImageElement>,
    private modalService: NgbModal,
    private servicesService: ServicesService,
    private secureStorage: SecureStorage,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private cookieservice: CookieService,
    private currentLanguageService: CurrentLanguage,
    public settingService: SettingService,
    private cdr: ChangeDetectorRef,
    private userService: UserDataService,
    public cultureLocaleService: CultureLocaleService,
    private applicationSourceService: ApplicationSourceService,
    private laborService: LaborService,
    private dmsService: DMSSyncFailedlogService,
    private toaster: ToastrService,
    config: NgbModalConfig,
    private dashboardService: DashboardService,
    private _eref: ElementRef

  ) {
    const supports = 'loading' in HTMLImageElement.prototype;

    if (supports) {
      nativeElement.setAttribute('loading', 'lazy');
    }

    config.backdrop = 'static';
    config.keyboard = false;
  }

  onReset() {
    this.servicesService.serviceListRequest.statusId = 0;
    this.servicesService.serviceListRequest.sourceId = 0;
    this.sourceName = null;
    this.servicesService.serviceListRequest.name = '';
    this.servicesService.serviceListRequest.serviceNo = '';
    this.servicesService.serviceListRequest.serviceCategoryName = '';
    this.servicesService.serviceListRequest.competenceName = '';
    this.servicesService.serviceListRequest.startRecordNumber = 0;
    this.servicesService.serviceListRequest.isNeedAttention = false;
    this.servicesService.serviceListRequest.isDiaplyPriceInWidget = false;
    this.servicesService.serviceListRequest.isFixedPrice = false;
    this.servicesService.serviceListRequest.isAdditionalCustomerComment = false;
    this.servicesService.serviceListRequest.hasChecklist = false;
    this.checkListSelected = false;
    this.isCustomerComment = false;
    this.isFixed = false;
    this.needAttention = false;
    this.displayPriceInWidget = false;
    this.servicesList = []
    this.getService();
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.servicesService.serviceListRequest.sortColumn = column;
    this.servicesService.serviceListRequest.sortDirection = direction;
    this.servicesService.serviceListRequest.startRecordNumber = 0;
    this.servicesList = [];
    this.getService();
  }

  onClose() {
    this.isAdvanceSearch = false;
  }

  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event && (event.target.className.indexOf('ng-option')==-1 && event.target.parentElement.className.indexOf('ng-option') == -1) && event.target.className.indexOf('btn')==-1) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }
  onSearchFilter() {
    this.servicesList = [];
    this.servicesService.serviceListRequest.startRecordNumber = 0;
    this.servicesService.serviceListRequest.searchTerm = this.searchTerm;
    this.getService();
  }
  onSearch() {
    if (this.servicesList == undefined) {
      this.getService();
    }

    this.cdr.detectChanges()
    this.isAdvanceSearch = true;
    this.cdr.detectChanges();
  }
  AdvanceSearchSubmit() {
    this.servicesService.serviceListRequest.startRecordNumber = Constant.startRecordNumber;
    this.servicesService.serviceListRequest.statusId = this.selectedStatus;
    this.servicesService.serviceListRequest.isNeedAttention = this.needAttention;
    this.servicesService.serviceListRequest.sourceId = this.SourceId;
    this.servicesList = []
    this.getService();
    this.isAdvanceSearch = false;
  }
  onApplyFilter() {
    this.AdvanceSearchSubmit();
  }

  ngOnInit(): void {
    if (this.dashboardService.isFromDashboard) {
      this.selectedStatus = Enums.StatusCode.Active;
    }
    if (this.selectedSync != undefined) {
      this.servicesService.serviceListRequest.syncId = this.selectedSync;
    }
    let status = 0;
    if (this.selectedStatus != undefined) {
      status = this.selectedStatus;
    }
    this.StatusList = this.dashboardService.getStatusList();
    this.SyncList = this.dashboardService.getDmsStatusList();
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Service);
    this.getFeatures();
    this.servicesService.serviceListRequest.cultureCode = this.cookieservice.get('userSelectedLanguage');
    this.servicesService.serviceListRequest.statusId = status;
    this.servicesService.serviceListRequest.startRecordNumber = 0;
    this.servicesService.serviceListRequest.searchTerm='';
    this.servicesList = [];
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.servicesService.serviceListRequest.cultureCode=x;
      this.getService();
    });
    this.GetApplicationSource();
  }
  async getFeatures() {
    let features = this.secureStorage.getKeyData('feature');
    if(features == null || features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        features = res;
        if (features?.length > 0) {
          this.integrationWithDMS = features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
          this.isDmsSyncService = features.find(x => x.featureCode === Enums.FeatureCode.RTDSS)?.isActive
        }
      })
    }else{
      this.integrationWithDMS = features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
      this.isDmsSyncService = features.find(x => x.featureCode === Enums.FeatureCode.RTDSS)?.isActive
    }
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    this.currentlagSub.unsubscribe();
    this.dashboardService.isFromDashboard = false;
  }

  SyncChange(status: any) {
    if (status == undefined) {
      this.servicesService.serviceListRequest.syncId = Enums.DmsSync.All;
    } else {
      this.servicesService.serviceListRequest.syncId = status;
    }
    this.servicesService.serviceListRequest.startRecordNumber = 0;
    this.servicesList = [];
    this.getService();
  }
  showActiveInactive(event: Event) {
    this.selectedStatus = +(event.target as HTMLInputElement).value;
  }



  StatusChange(status: Enums.StatusCode) {
    if (status == undefined) {
      status = Enums.StatusCode.All;
    }
    this.servicesService.serviceListRequest.statusId = status;
    this.servicesService.serviceListRequest.startRecordNumber = 0;
    this.servicesList = [];
    this.getService();
  }
 
  onScrollDown(_ev) {
    if(this.totalCount > this.servicesList.length){
      this.servicesService.serviceListRequest.startRecordNumber = this.servicesList.length;
      this.getService(true);
    }
  }

  async getService(scroll:boolean = false) {
    this.spinner.show();
    if(!scroll)
    {
      this.servicesList = [];
      this.servicesService.serviceListRequest.startRecordNumber = 0;
    }
    await this.servicesService.getServiceList(this.servicesService.serviceListRequest).then((response) => {
      this.totalCount = 0;
      if(response != null && response.length != 0){
          if(this.servicesList.length != response[0].totalCount)
           this.servicesList.push(...this.ServiceDataMapper(response));
          this.totalCount = 0;
          if(this.servicesList.length > 0)
             this.totalCount = this.servicesList[0].totalCount;
        this.spinner.hide();
      }
      else
      {
        this.spinner.hide();
      }

    },_error => {
      this.spinner.hide();
    });

  }

  onAdd() {
    const modalref = this.modalService.open(AddServiceComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  deleteService(id: any) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblService"),true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.servicesService.deleteService(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let successMsg = this.translate.instant("lblDeleteService");
            this.toastr.success(successMsg)
            this.servicesService.serviceListRequest.startRecordNumber = 0;
            this.servicesList = [];
            this.getService();
          }
          if (response.responseCode == Constant.ResponseCode) {
            let errorMsg = this.translate.instant("lblDeleteServiceErrorMsg");
            this.toastr.error(errorMsg);
          }
        });
      }
    });
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  onEdit(services: ServiceViewModel) {
    this.servicesService.serviceId = services.id;
    const modalref = this.modalService.open(EditServiceComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.servicesList = [];
        this.getService();
      }
    });
  }

  private ServiceDataMapper(service: any) {
    let supperArray = [];
    if (service && service.length > 0) {

      for (let index = 0; index < service.length; index++) {
        const element = service[index];

        let single = Object();
        single.rowNumber =
        this.servicesService.serviceListRequest.startRecordNumber + 1 + index;
        single.description = element.description
        single.displayPriceInWidget = element.displayPriceInWidget
        single.duration = element.duration ? +element.duration : 0;
        single.id = element.id
        single.isActive = element.isActive
        single.logo = element.logo
        single.name = element.name
        single.price = element.price ? element.price : 0;
        single.serviceCategoryId = element.serviceCategoryId
        single.serviceCategoryName = element.serviceCategoryName
        single.competenceId = element.competenceId
        single.competenceName = element.competenceName
        single.widgetSequence = element.widgetSequence
        single.plannerSequence = element.plannerSequence
        single.serviceNo = element.serviceNo
        single.totalCount = element.totalCount
        single.updatedDate = element.updatedDate ? new Date(element.updatedDate + 'Z') : null;
        single.dmsSyncDate = element.dmsSyncDate ? new Date(element.dmsSyncDate + 'Z') : null;
        single.createdDate = element.createdDate ? new Date(element.createdDate + 'Z') : null;
        single.sourceType = element.sourceType
        single.dmsSyncStatus = element.dmsSyncStatus
        single.needAttention = element.needAttention
        supperArray.push(single);
      }
    }

    return supperArray;
  }

  onSyncToDms(Id){
    let modelHeadermsg = this.translate.instant("lblSyncToDMS");
    let modelBodymsg = this.translate.instant("lblSureToSync");
    let errorMsg = this.translate.instant('lblErrormsg');
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
       // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.laborService.ResyncLabor(Id).then((response) => {
          this.spinner.hide();
          if (response.responseObject.isSuccess) {
            let successMsg = this.translate.instant('lblSyncSuccess')
            this.toaster.success(successMsg);
            this.servicesList = [];
            this.servicesService.serviceListRequest.startRecordNumber = 0;
            this.getService();
          } else {
            this.spinner.hide();
            this.toaster.error(errorMsg);
          }
        });
      }
    });
  }
  viewException(Id){
    this.dmsLogRequestModel.referenceId = Id;
    this.spinner.show();
    let errorMsg = this.translate.instant('lblNoErrorDetails');
    this.dmsService.GetDmsSyncFailedLog(this.dmsLogRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.spinner.hide();
        if (response.responseObject.length > 0) {
          let ex = response.responseObject[0].exceptionMessage;

          let modelHeadermsg = this.translate.instant("lblException");
          const modalRef = this.modalService.open(NgInfoModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = ex;
          modalRef.result.then((_result) => {
            // This is intentional
          }, (reason) => {
            this.popupCloseResult = this.getDismissReason(reason);
          });
        } else {
          this.toaster.error(errorMsg);
        }
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }
  changeNeedAttention(event: Event) {
    this.needAttention = (event.target as HTMLInputElement).checked;
    this.servicesService.serviceListRequest.isNeedAttention = this.needAttention
  }
  DisplayPriceInWidget(event: Event) {
    this.displayPriceInWidget = (event.target as HTMLInputElement).checked;
    this.servicesService.serviceListRequest.isDiaplyPriceInWidget = this.displayPriceInWidget
  }
  OnChangeClick(event:Event){
  this.isFixed = (event.target as HTMLInputElement).checked;
  this.servicesService.serviceListRequest.isFixedPrice = this.isFixed;
   }
  OnChangeAdditionalComment(event:Event){
    this.isCustomerComment = (event.target as HTMLInputElement).checked;
    this.servicesService.serviceListRequest.isAdditionalCustomerComment = this.isCustomerComment;
  }
  OnChangeCheckListSelected(event:Event){
    this.checkListSelected = (event.target as HTMLInputElement).checked;
    this.servicesService.serviceListRequest.hasChecklist = this.checkListSelected;
  }
  async GetApplicationSource(): Promise<void> {
    await this.applicationSourceService.getApplicationSource().then(data => {
      this.applicationSourceList = data.responseObject;
      this.applicationSourceList = this.applicationSourceList.filter(source => source.sourceId === Enums.SourceId.Planner || source.sourceId === Enums.SourceId.DMS);
    });
  }
  SourceChange(status: any) {
    this.SourceId = status;
    this.servicesService.serviceListRequest.startRecordNumber = 0;
  }

}
